import { User } from '@auth0/auth0-spa-js';
import { Tooltip } from '../components/ui/tooltip';
import { IUser } from '@monetize/types/app';
import { FC } from 'react';
import { Link as ReactDomLink } from 'react-router-dom';
import { MAvatar, MBox, MFlex, MLink, MText } from '../components/Monetize';
import { ROUTES } from '../constants';

interface ProfileNavProps {
  isOverlay: boolean;
  user?: User;
  currentTenantUser: IUser;
}
export const ProfileNav: FC<ProfileNavProps> = ({
  isOverlay,
  user,
  currentTenantUser,
}: ProfileNavProps) => {
  const displayName = currentTenantUser.name || user?.name || '';

  return (
    <MFlex
      py={1}
      px={isOverlay ? 0 : 4}
      justifyContent={isOverlay ? 'center' : 'flex-start'}
    >
      <MLink
        asChild
        role="group"
        className="group"
        display="flex"
        alignItems="center"
        borderRadius="md"
        p={1}
        w={isOverlay ? 'auto' : '100%'}
        textDecoration="none"
        _hover={{ textDecoration: 'none' }}
        _focusVisible={{
          outline: 'none',
          boxShadow: 'focus',
        }}
      >
        <ReactDomLink to={ROUTES.PROFILE}>
          <Tooltip
            content="Profile"
            disabled={!isOverlay}
            positioning={{
              placement: 'bottom-end',
            }}
          >
            <MAvatar
              name={displayName}
              src={user?.picture}
              size="sm"
              _groupHover={{
                boxShadow: '0 0 0 2px {colors.tIndigo.base}',
              }}
            />
          </Tooltip>
          {!isOverlay && (
            <MBox overflow="hidden" ml={3} maxW="8rem">
              <MText
                title={displayName}
                fontSize="xs"
                fontWeight={600}
                truncate
                _groupHover={{ color: 'tIndigo.base' }}
              >
                {displayName}
              </MText>
              <MText
                title={currentTenantUser.email}
                fontSize="xs"
                color="tGray.darkPurple"
                truncate
                _groupHover={{ color: 'tIndigo.base' }}
              >
                {currentTenantUser.email}
              </MText>
            </MBox>
          )}
        </ReactDomLink>
      </MLink>
    </MFlex>
  );
};
